export const getSelectedSupplierInfoAddressList = (state) => {
    const { info, supplierInfo } = state;

    if (
        typeof info.selectedParentID != 'undefined' &&
        typeof supplierInfo[info.selectedParentID] != 'undefined'
    ) {
        return supplierInfo[info.selectedParentID].Addresses;
    }

    return [];
};
export const getUserFullInfo = (userInfo, masterAddressList) => {
    let newUserInfo = {
        ...userInfo,
        availableAddresses: [],
    };

    if (userInfo.availableAddresses) {
        newUserInfo.availableAddresses = userInfo.availableAddresses.map(
            (item) => masterAddressList[item]
        );
    }

    return newUserInfo;
};
export const getCurrentlyPurchasingUser = (store) => {
    const { user, purchasingUser } = store;
    const { orderOnBehalf } = user;

    return orderOnBehalf ? purchasingUser : user;
};

export const getDispatchLocations = (store) => {

    const { user } = store;

    return user.info.availableDispatchLocations;
}

export const getDefaultDispatchLocationID = (store) => {

    const { user } = store;

    return user.info.defaultDisaptchLocationID;
}